export default __webpack_public_path__ + "static/userflow-aae2569a223ca923fe70e82a270604d8.png";